<template>
  <div :class="blockClass">
    <div class="releasecontainer">
      <div class="releaseheader">
        <div>
          <div class="sdkname">{{release.sdk}}</div>
          <div class="version">{{release.version}}</div>
        </div>
        <div class="releasedateblock">
          <span>Released on</span>&nbsp;<span class="releasedate">{{formattedDate}}</span>
        </div>
        <div>
          <a :href="apiUrl"><div class="button">API</div></a>
        </div>
      </div>
      <div class="example" v-html="formattedExample"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'whatwg-fetch'
import markdown from 'marked'

export default {
  name: 'release-block',
  props: ['release', 'index'],
  mounted() {
    fetch('releases/' + this.release.example).then(response => {
      return response.text();
    }).then(exampleText => {
      this.exampleText = exampleText;
    });
  },
  computed: {
    blockClass () {
      return 'release' + this.index % 2;
    },
    formattedDate () {
      return moment(this.release.date).format("MMM Do, YYYY");
    },
    formattedExample () {
      return markdown(this.exampleText, { sanitize: true });
    },
    apiUrl () {
      return 'releases/' + this.release.reference;
    },
    changelogUrl () {
      return 'releases/' + this.release.changelog;
    }
  },
  data () {
    return {
      exampleText: ""
    }
  }
}
</script>

<style>

.release0 {
  padding: 6em 2em;
  position: relative;
  height: auto;
  background: #006a94;
  z-index: 2;
}

.release1 {
  padding: 6em 2em;
  position: relative;
  height: auto;
  background: #004561;
  z-index: 2;
}

.releasecontainer {

}

.releaseheader {
  display: inline-block;
  vertical-align:top;
  margin: 1em;
}

.sdkname {
  display: inline-block;
  font-size: 2em;
  color: #ffffff;
  text-transform: uppercase;
  font-weight:bolder;
}

.version {
  display: inline-block;
  font-size: 2em;
  color: #ffffff;
  opacity: 0.8;
  font-weight:400;
}

.releasedateblock {
  font-size: 0.9em;
  color: #ffffff;
}

.releasedate {
  font-size: 0.9em;
  color: #ffffff;
  opacity: 0.8;
  font-weight:bold;
}

.button {
  display:inline-block;
  color: #000000;
  font-size: 0.8em;
  width: 10em;
  background-color: #e0f6ff;
	cursor:pointer;
  margin: 1em 0.5em;
  padding: 0.5em 1em;
	-moz-border-radius:20px;
	-webkit-border-radius:20px;
	border-radius:20px;
	text-decoration:none;
  text-transform: uppercase;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.button:active {
  background-color: #b9ebff;
}

.example {
  position: relative;
  display: inline-block;
  max-width: 600px;
  text-align: left;
  font-family: monospace;
  vertical-align:top;
  height: auto;
  margin: 1.5em;
  padding: 1em;
  background-color: #b9ebff;
	-moz-border-radius:5px;
	-webkit-border-radius:5px;
	border-radius:5px;
}

.example pre {
  overflow-x: auto;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;       /* css-3 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
}

</style>



// WEBPACK FOOTER //
// ReleaseBlock.vue?85fe60de